import React from "react";

const timeAgo = (timestamp) => {
  const now = new Date();
  const seconds = Math.floor((now - new Date(timestamp)) / 1000);

  if (seconds < 60) return "Just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(timestamp).toLocaleDateString(); // Full date for older timestamps
};

const TimeAgo = ({ timestamp }) => {
  return <span className="text-gray-700 text-xs dark:text-gray-400">{timeAgo(timestamp)}</span>;
};

export default TimeAgo;
